import { render, staticRenderFns } from "./CBAVJKIK.vue?vue&type=template&id=a1b34666&scoped=true&"
import script from "./CBAVJKIK.vue?vue&type=script&lang=js&"
export * from "./CBAVJKIK.vue?vue&type=script&lang=js&"
import style0 from "./CBAVJKIK.vue?vue&type=style&index=0&id=a1b34666&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b34666",
  null
  
)

export default component.exports